export default __webpack_public_path__ + "static/sida-shen-profile-fbbb98204940da1c41ade8f563e9691f.jpeg";